module.exports = __webpack_public_path__ + "img/crecer-small.3ef15de2.png";